import { Box, Typography, Button, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Home as HomeIcon, ErrorOutline as ErrorIcon } from "@mui/icons-material";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Paper elevation={3} sx={{ p: 5, textAlign: "center", maxWidth: 500 }}>
        <ErrorIcon sx={{ fontSize: 80, color: "text.secondary", mb: 2 }} />
        <Typography variant="h4" component="h1" gutterBottom fontWeight={600}>
          Página no encontrada
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          La página que intentas acceder no existe o ha sido movida.
        </Typography>
        <Button variant="contained" startIcon={<HomeIcon />} onClick={() => navigate("/")} size="large">
          Volver al Inicio
        </Button>
      </Paper>
    </Box>
  );
}
